<ejs-dialog [isModal]='isModal'
            [button]
            [visible]='true' [position]='position'
            [animationSettings]='animationSettings'
            [width]='modalWidth'
            role="alertdialog"
            aria-modal="true"
            >
  <ng-template #content>
    <div class="card">
      <div class="card-header bg-primary">
        <h3 class="card-title text-white" tabindex="0" aria-label="FDA Submission Status" role="heading" aria-level="3">FDA Submission Status</h3>
      </div>
      <div class="card-body">
        <div>
          <div tabindex="0">
            Your Site is not enabled for ESG submissions to the FDA. Contact pharma@reedtech.com to add this ability.
          </div>
        </div>
        <div class="text-end">
          <button id="noAccessModalClose" class="btn btn-primary" (click)="noAccessModalClose($event)" data-ripple="true"
                  tabindex="0" role="button" aria-label="Ok" (keydown.enter)="noAccessModalClose($event)">
            OK
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ejs-dialog>
